import flatpickr from 'flatpickr';
export const datepicker = (element, options) => {
    flatpickr(element, options);
    return {
        update(options) {
            flatpickr(element, options);
        }
    };
};
